export const getQueryParams = (urlString: string): any => {
    const url = new URL(urlString);
    const queryParams: any = {};
    url.searchParams.forEach((value: string, key: string) => {
        queryParams[key] = value;
    });

    return queryParams;
}